<template>
    <div>
        <div class="button-area">
            <!--      <Button-->
            <!--        @click="save()"-->
            <!--        :loading="saveLoading"-->
            <!--        type="primary"-->
            <!--        class="button-right-left"-->
            <!--        >保存</Button-->
            <!--      >-->
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form
                    style="width: 900px"
                    :model="model"
                    :label-width="110"
                    label-position="left"
                    inline
            >
                <FormItem :class="{ 'model-hidden': true }" label="文本框">
                    <Input v-model="model.id" type="text"></Input>
                </FormItem>
                <FormItem label="用户姓名">
                    <Input
                            readonly
                            v-model="model.name"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <br/>
                <FormItem label="手机号">
                    <Input
                            readonly
                            v-model="model.phone"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <br/>
                <FormItem label="身份证">
                    <Input
                            readonly
                            v-model="model.sfz"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <br>
                <FormItem label="身份证正面照片">
                    <previewImg style="width: 200px;height: 160px" v-if="model.idCardFrontPic" :src="model.idCardFrontPic"
                         alt=""/>
                    <img style="width: 200px;height: 160px" v-else :src="require('../../../../assets/noPic.jpg')" alt=""/>
                </FormItem>
                <br>
                <FormItem label="身份证背面照片">
                  <previewImg style="width: 200px;height: 160px" v-if="model.idCardBackPic" :src="model.idCardBackPic"
                       alt=""/>
                    <img style="width: 200px;height: 160px"  :src="require('../../../../assets/noPic.jpg')" alt="" v-else/>
                </FormItem>
                <br/>
                <br/>
                <FormItem label="申请认证时间">
                    <Input
                            readonly
                            v-model="model.createTime"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <br/>
            </Form>
        </div>

        <div style="width:900px;margin:0 auto;padding-bottom: 20px">
            <strong>关联企业</strong>
            <br>
            <template v-for="(item,index) in userToCompany">
                <div>{{index+1}}、{{item.company.name}}</div>
            </template>
        </div>

    </div>
</template>

<script>
    import util from '@/libs/util.js'
    import Template from '../../../form/components/Template'
    import previewImg from '@/components/previewImg'
    export default {
        name: 'tqtUserForm',
        components: { Template,previewImg },
        data () {
            return {
                //ID
                id: null,
                saveLoading: false,
                //表单参数
                model: {
                    name: null,
                    phone: null,
                    sfz: null,
                    pic: null,
                    idCardFrontPic: null,
                    idCardBackPic: null,
                    createTime: null,
                },
                userToCompany: []
            }
        },
        mounted () {
            if (typeof this.$route.query.id !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id
                //ID存在渲染表单
                this.initForm()
            }
        },
        methods: {
            formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }

                function formatFunc (str) {
                    //格式化显示
                    return str > 9 ? str : '0' + str
                }

                var date2 = new Date(UTCDateString) //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = date2.getSeconds() // var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + second
                var dateStr = year + '-' + mon + '-' + day
                return dateStr
            },
            //保存
            save () {
                if (this.id) {
                    this.update()
                } else {
                    this.create()
                }
            },

            create () {
                let _this = this
                _this.saveLoading = true
                util.http
                        .get('/api/user/details', this.model, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '保存成功!',
                            })
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '保存失败!',
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },

            update () {
                let _this = this
                _this.saveLoading = true
                util.http
                        .get('/api/user/details', this.model, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '更新成功!',
                            })
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '更新失败!',
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },
            //渲染表单
            initForm () {
                let _this = this
                util.http.get('/api/user/details/' + this.id, {
                    params: {},
                }).then(function (response) {
                    let tem = response.data.baseInfo
                    _this.model.id = tem.id
                    _this.model.name = tem.name
                    _this.model.phone = tem.phone
                    _this.model.sfz = tem.sfz
                    _this.model.pic = tem.pic
                    _this.model.idCardFrontPic = tem.idCardFrontPic.url
                    _this.model.idCardBackPic = tem.idCardBackPic.url
                    _this.model.createTime = _this.formatTime(tem.createTime)
                    let userToCompany = response.data.userToCompany
                    _this.userToCompany = userToCompany
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '获取表单失败!',
                    })
                    console.log(error)
                })
            },

            //返回,需要自定义配置路由
            back () {
                if(this.$route.query.backPath){
                    this.$store.commit('app/closePage', {
                        vm: this,
                        route:{
                            path: this.$route.query.backPath,
                        }
                    })
                }else
                    this.$store.commit('app/closePage', {
                        vm: this,
                        route:{
                            name: 'tqt_user',
                        }
                    })
            },
        },
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }
</style>
